var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmation1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 72,
    viewBox: "0 0 104 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1428 28.2848C96.5017 58.4456 71.9294 71.9991 52.5559 71.9991C33.1825 71.9991 8 55.7086 8 38.3582C8 21.0078 12.6244 10.2035 32.1126 3.51306C51.6008 -3.17735 91.784 -1.87594 94.1428 28.2848Z",
    fill: "#F7F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27393_18621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1428 19.9684C37.1428 18.7626 38.1417 17.7852 39.3739 17.7852C47.6008 17.7852 55.8277 17.7852 64.0546 17.7852C65.2868 17.7852 66.2857 18.7627 66.2857 19.9685V53.8519C66.2857 55.0577 65.2868 56.0352 64.0546 56.0352C55.8277 56.0352 47.6008 56.0352 39.3739 56.0352C38.1417 56.0352 37.1428 55.0577 37.1428 53.8519V19.9684Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 16.3259C33.5 15.1201 34.4989 14.1426 35.7311 14.1426C43.958 14.1426 52.1849 14.1426 60.4118 14.1426C61.644 14.1426 62.6429 15.1201 62.6429 16.3259V50.2093C62.6429 51.4151 61.644 52.3926 60.4118 52.3926C52.1849 52.3926 43.958 52.3926 35.7311 52.3926C34.4989 52.3926 33.5 51.4151 33.5 50.2093V16.3259Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2234,
    y: 41.5762,
    width: 7.28571,
    height: 3.64286,
    transform: "rotate(45 56.2234 41.5762)",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5084,
    y: 44.5723,
    width: 14.5862,
    height: 5.46429,
    rx: 2,
    transform: "rotate(45 60.5084 44.5723)",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.7858,
    y: 34.1777,
    width: 14.5714,
    height: 1.82143,
    rx: 0.910714,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.9642,
    y: 19.6074,
    width: 9.10714,
    height: 1.82143,
    rx: 0.910714,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.7858,
    y: 37.8203,
    width: 12.75,
    height: 1.82143,
    rx: 0.910714,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.8928,
    cy: 35.9989,
    r: 10.1786,
    stroke: "#8E8CEE",
    strokeWidth: 1.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2759 7.24C10.0039 7.336 9.51591 7.464 8.81191 7.624C8.10791 7.768 7.55591 7.864 7.15591 7.912L6.89191 6.232C7.75591 6.056 8.65191 5.744 9.57991 5.296C10.5239 4.832 11.2919 4.352 11.8839 3.856H11.9079L13.8039 4.12V17.32L16.5399 17.584V19H7.39591V17.584L10.2759 17.344V7.24Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27393_18621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.7143,
    height: 43.7143,
    fill: "white",
    transform: "translate(29.8572 14.1426)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation1);
export default __webpack_public_path__ + "static/media/confirmation1.4086dd3691a3944e5213fe3e5a0261f0.svg";
export { ForwardRef as ReactComponent };